import React from "react";
import { useNavigate } from "react-router-dom";
import { Save, Loader2 } from "lucide-react";
import { Card } from "src/components/ui/Card";
import { Button } from "src/components/ui/Button";
import { SessionSchedulingType } from "src/services/sessionsService";

interface SchedulingActionTrayProps {
  isSubmitting: boolean;
  schedulingType: SessionSchedulingType;
  scheduledDatesCount: number;
}

export const SchedulingActionTray: React.FC<SchedulingActionTrayProps> = ({
  isSubmitting,
  schedulingType,
  scheduledDatesCount,
}) => {
  const navigate = useNavigate();

  return (
    <Card className="border border-slate-200 rounded-xl p-5 shadow-xs bg-white space-y-3 font-sans">
      <Button
        type="submit"
        form="schedule-session-form"
        disabled={isSubmitting}
        className="w-full h-10 rounded-lg bg-purple-600 hover:bg-purple-700 text-white font-bold text-xs tracking-wide shadow-xs flex items-center justify-center gap-2 transition"
      >
        {isSubmitting ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Save className="h-4 w-4" />
        )}
        <span>
          {schedulingType === "recurring"
            ? `Confirm & Schedule ${scheduledDatesCount}-Session Series`
            : "Confirm & Schedule Session"}
        </span>
      </Button>
      
      <Button
        type="button"
        variant="outline"
        onClick={() => navigate("/admin/sessions")}
        disabled={isSubmitting}
        className="w-full h-9 rounded-lg bg-white hover:bg-slate-50 text-slate-700 font-semibold text-xs border border-slate-300 transition"
      >
        Cancel / Discard
      </Button>

      <p className="text-center text-xs text-slate-400">
        Esc to discard • Validates schedule against tutor conflict radar
      </p>
    </Card>
  );
};

